import { QueryBuilderBootstrap } from "@react-querybuilder/bootstrap";
import 'react-querybuilder/dist/query-builder.scss';
import { EMPTY_GUID, lowercaseKeys } from "@utils/helpers";
import { upsertCustomerFeedback } from "features/journey-map/reducer/CJMActions";
import { useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import QueryBuilder, { ActionElement } from "react-querybuilder";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Form } from "reactstrap";
import { GenericButton } from "shared/ui-basics/buttons";
import * as Styles from "../Styles";
import { ConnectorSource } from "@utils/optionsSets/OptionSets";
import { connectorInit, getQuestionsAndFilters } from "features/integrations/reducer/ConnectorAction";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import PropTypes from "prop-types";
import { IconDispatcher } from "shared/Icons";
import { Labels } from "shared/cx-components/style";
import { GenericDropdown } from "shared/dropdowns/GenericDropdown";
import { Label } from "shared/ui-basics";
import { FeedBackData } from "./FeedBackData";
import ReportSummeryFeedback from "./report-summery-feedback";

export const FeedbackConfiguration = ({ currentItem, isViewer, onClose }) => {

	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { cjmIdStr } = useLocation()?.search.getMapsParams();
	const connector = useSelector((state) => state.settings.connector)?.getById(currentItem?.connectorId);
	const { jsonSurveys, source, enableConnection } = connector;
	const listSurvey = jsonSurveys.replaceAll('"Name"', '"value"') || "[]";

	const surveyData = JSON.parse(listSurvey)?.map((x) => lowercaseKeys(x));

	const [feedback, setFeedback] = useState(currentItem)

	const [loadingSurvey, setLoadingSurvey] = useState(false);
	const [listFilter, setListFilter] = useState([]);
	const [listQuestions, setListQuestions] = useState([]);
	const [query, setQuery] = useState(currentItem?.jsonCondition ? JSON.parse(currentItem?.jsonCondition) : { combinator: "and", rules: [] });
	const [validated, setValidated] = useState(true);
	const [key, setKey] = useState("report");

	const isDisable = currentItem.retrieveData || !loadingSurvey || isViewer;

	useEffect(() => {
		if (feedback.surveyId) {
			onSelectSurvey(feedback.surveyId);
		}
	}, []);

	const handleChange = (e, type) => {
		if (e.target) {
			const { value } = e.target;
			setFeedback({ ...feedback, [type]: value });
		} else {
			setFeedback({ ...feedback, touchPointId: e || EMPTY_GUID });
		}
	};
	const changeSurvey = (e) => {
		const { value } = e.target;
		setFeedback({ ...feedback, surveyId: value });
		onSelectSurvey(value);
	};
	const onSelectSurvey = (surveyId) => {
		//call api
		setLoadingSurvey(false);
		const callbacks = {
			onSuccess: fillResult,
			onFailed: () => setLoadingSurvey(true),
		};
		getQuestionsAndFilters({ connectorId: feedback?.connectorId, surveyId, ...callbacks });
	};

	const fillResult = (data) => {
		setListFilter(data?.Filters?.map((x) => lowercaseKeys(x)).sortAsc("value"));
		setListQuestions(data?.Questions?.map((x) => lowercaseKeys(x)));
		setLoadingSurvey(true);
	};

	const transfertQuestion = () => {
		return listQuestions?.map((question) => {
			return {
				name: question?.id, label: question?.value !== "" ? question?.value : question?.id, inputType: 'number',
				operators: [
					{ name: '=', label: 'equals' },
					{ name: '!=', label: 'not equals' },
				]
			}
		})
	}
	const fields = transfertQuestion();
	const validation = () => {
		const { filterId, surveyId, cxMetricsId, ratingQuestionId } = feedback;
		return !surveyId?.isEmptyString() && !cxMetricsId?.isEmptyString() && !ratingQuestionId?.isEmptyString();
	}
	const startRetrieveData = () => {
		if (validation()) {
			setFeedback({ ...feedback, retrieveData: true });

			upsertCustomerFeedback({ customerFeedback: { 
				...currentItem, 
				surveyId: feedback.surveyId,
				ratingQuestionId: feedback.ratingQuestionId,
				filterId: feedback.filterId,
				retrieveData: true, 
				jsonCondition: JSON.stringify(query) 
			}, 
				cjmId: cjmIdStr })
		}
		else {
			setValidated(false);
		}
	}
	const update = () => {
		upsertCustomerFeedback({ customerFeedback: { ...currentItem,
			surveyId: feedback.surveyId,
			ratingQuestionId: feedback.ratingQuestionId,
			filterId: feedback.filterId, jsonCondition: JSON.stringify(query) }, cjmId: cjmIdStr })
		onClose();
	}
	const confirmRetrieveData = (event) => {
		confirmPopup({
			target: event.currentTarget,
			className: "w-25",
			message: t("RETRIEVE_DATA_QUALTRICS"),
			icon: 'pi pi-info-circle',
			acceptClassName: 'p-button-danger  confirm-popup-button p-1',
			rejectClassName: "p-button-outlined confirm-popup-button p-1",
			rejectLabel: t("SAVE_RESUME"),
			acceptLabel: t("START_RETRIEVING"),
			accept: startRetrieveData,
			reject: update
		});
	};
	const customStyles = {
		menu: (provided) => ({
			...provided,
			maxWidth: 200,
			whiteSpace: "normal",
			overflowWrap: "break-word",
		}),
		option: (provided) => ({
			...provided,
			maxWidth: 200,
			whiteSpace: "normal",
			overflowWrap: "break-word",
		}),
	};
	return (<div>
		<Styles.DivSurveyWrapper className='mt-3'>
			<Styles.DivSurveyLabel >
				<Label size={14}>{t("Survey Details")}</Label>
			</Styles.DivSurveyLabel>
			<Form className="px-3">

				<Row className="pt-4">
					<Col xs={3}>
						<Labels className="">{t("SURVEY")}</Labels>
					</Col>
					<Col xs={9}>
						<GenericDropdown
							search={"true"}
							border
							icon
							validated={feedback?.surveyId?.isEmptyString() && !validated}
							options={surveyData}
							placeholder={t("SELECT_SURVEY")}
							value={feedback?.surveyId}
							onClick={changeSurvey}
							disabled={feedback.retrieveData}
						/>
						<Styles.FormFeedbackWrapper display={(feedback?.surveyId?.isEmptyString() && !validated)?.toString()}>
							{IconDispatcher("INFO", "me-2")}
							{t("MANDATORY")}
						</Styles.FormFeedbackWrapper>
					</Col>
				</Row>

				{source === ConnectorSource.Qualtrics && (
					<Row className="pt-4">
						<Col xs={3} >
							<Labels className="">{t("FILTER")}</Labels>
						</Col>
						<Col xs={9} >
							<GenericDropdown
								border
								icon
								search={"true"}
								options={listFilter}
								disabled={isDisable}
								placeholder={t("SELECT_FILTER")}
								value={feedback?.filterId}
								name="filterId"
								onClick={(e) => handleChange(e, "filterId")}
							/>
						</Col>
					</Row>
				)}
				<Row className="pt-4">
					<Col xs={3} >
						<Labels className="">{t("RATING_QUESTION")}</Labels>
					</Col>
					<Col xs={9} >
						<GenericDropdown
							search={"true"}
							border
							validated={feedback?.ratingQuestionId.isEmptyString() && !validated}
							icon
							options={listQuestions}
							placeholder={t("SELECT_QUESTION")}
							value={feedback?.ratingQuestionId}
							name="ratingQuestionId"
							onClick={(e) => handleChange(e, "ratingQuestionId")}
							disabled={feedback.retrieveData}
						/>
						<Styles.FormFeedbackWrapper display={(feedback?.ratingQuestionId.isEmptyString() && !validated).toString()}>
							{IconDispatcher("INFO", "me-2")} {t("MANDATORY")}
						</Styles.FormFeedbackWrapper>
					</Col>
				</Row>
				{source === ConnectorSource.Qualtrics && (
					<Row className="py-4">
						<Col xs={3} >
							<Labels className="">{t("CONDITION")}</Labels>
						</Col>
						<Col xs={9} >
							<Styles.QueryBuilderDiv>
								<QueryBuilderBootstrap>
									<QueryBuilder
										disabled={isDisable}
										fields={fields}
										query={query}
										onQueryChange={(q) => setQuery(q)}
										controlClassnames={{
											// queryBuilder: "queryBuilder-branches",
											valueEditor: (props) => (
												<props.valueEditorComponent
													{...props}
													selectProps={{
														...props.selectProps,
														styles: customStyles, // Pass the custom styles
													}}
												/>
											),
										}}
										controlElements={{
											addGroupAction: (props) => (props?.level === 0 ? <ActionElement {...props} /> : null),
										}}
									/>
								</QueryBuilderBootstrap>
							</Styles.QueryBuilderDiv>
						</Col>
					</Row>
				)}
			</Form>
		</Styles.DivSurveyWrapper >
		{!currentItem.retrieveData && <div className="d-flex justify-content-start py-3">
			<ConfirmPopup />
			<GenericButton variant="dark" onClick={update} disabled={feedback.retrieveData} className="me-3">
				{t("SAVE_RESUME")}
			</GenericButton>
			<GenericButton variant="dark-outline" onClick={confirmRetrieveData} disabled={feedback.retrieveData}>
				{t("RETRIEVE_DATA")}
			</GenericButton>
		</div>
		}
		{feedback?.connectorId !== EMPTY_GUID && currentItem.retrieveData &&
			<div className="pt-4">
				<Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3 fs2">
					<Tab key={"report"} eventKey={"report"} title={t("Trend")}>
						<ReportSummeryFeedback feedback={feedback} showStopRetrieveData={true} />
					</Tab>
					<Tab key={"table"} eventKey={"table"} title={t("Data Table")}>
						<FeedBackData feedback={feedback} />
					</Tab>

				</Tabs>
			</div>
		}

	</div>
	);
};

FeedbackConfiguration.propTypes = {
	feedback: PropTypes.object,
	setFeedback: PropTypes.func,
	isViewer: PropTypes.bool,
	onClose: PropTypes.func,
};
ActionElement.propTypes = {
	level: PropTypes.number,
};
